import { render, staticRenderFns } from "./transView.vue?vue&type=template&id=5aa0f612&scoped=true"
import script from "./transView.vue?vue&type=script&lang=js"
export * from "./transView.vue?vue&type=script&lang=js"
import style0 from "./transView.vue?vue&type=style&index=0&id=5aa0f612&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa0f612",
  null
  
)

export default component.exports